// How an enquiry's category (enquiries.category, enquiry_import_rows.category)
// is shown. One map for every surface that prints it.
const ENQUIRY_CATEGORY_LABEL = {
  employee: 'Employee',
  candidate: 'Candidate',
}

export default ENQUIRY_CATEGORY_LABEL
